import cx from "@hsl/core/utils/cx";

import PDFSVG from "../../assets/pdf.svg";

const PDFIcon = ({ className }: { className?: string }) => (
    <img className={cx("h-4 w-4", className)} src={PDFSVG} />
);

export default PDFIcon;
